// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__NCPp5","buttons":"SendReceipts_buttons__3FvFJ","email":"SendReceipts_email__160ki","bookApptTitle":"SendReceipts_bookApptTitle__16X1O"};